import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Container } from "@mui/material";
import { getDataRequest, postDataRequest } from "../../helper/AxiosHelper";
import { validateForm } from "../../helper/FormHelper.jsx";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import FormContent from "../../components/organization/orgGrpFormSchema.jsx";
import OrgGrpForm from "../../components/organization/OrgGrpForm.jsx";

export default function Component() {
  const { org_id: orgId } = useParams();
  const navigate = useNavigate();
  const formik = useFormik(FormContent.FormikInstance);
  const [orgData, setOrgData] = useState({});

  useEffect(() => {
    getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
      if (!isSuccess) {
        return;
      }
      setOrgData(data.record || {});
    });
  }, [orgId]);

  const handleCreate = async () => {
    if (await validateForm(formik)) return;

    const payload = {
      org_id: Number(orgId),
      grp_code: formik.values.grp_code.trim(),
      name_zh: formik.values.name_zh.trim(),
      name_en: (formik.values.name_en || "").trim(),
      display_pos: Number(formik.values.display_pos),
    };

    postDataRequest("orgGrp/create", payload, (isSuccess) => {
      if (!isSuccess) {
        return toast.error("新增失敗");
      }
      toast.success("新增成功");
      setTimeout(() => navigate(`/organization/${orgId}/grps`), 1500);
    });
  };

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb
        dbData={{
          organization_id: orgId,
          organization_name: orgData?.name_zh,
        }}
      />
      <OrgGrpForm formik={formik} submitLabel="新增" onSubmit={handleCreate} />
    </Container>
  );
}
